import actions from "./actions";

const initialState = {
  error: null,
  saving: false,
  loadingDetail: false,
  detail: null,
  loadingList: false,
  items: [],
  total: 0,
  current: null,
  loadingCurrent: false,
  histories: [],
  loadingHistories: false,
};

export default function tllBulkReservationSettingReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case actions.LIST_REQUEST:
    case actions.SEARCH_REQUEST:
      return { ...state, loadingList: true, error: null };
    case actions.LIST_SUCCESS:
      return {
        ...state,
        loadingList: false,
        items: action.items || [],
        total: Array.isArray(action.items) ? action.items.length : 0,
      };
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        loadingList: false,
        items: action.items || [],
        total: Number.isFinite(Number(action.total)) ? Number(action.total) : 0,
      };
    case actions.LIST_ERROR:
    case actions.SEARCH_ERROR:
      return {
        ...state,
        loadingList: false,
        items: [],
        total: 0,
        error: action.error,
      };
    case actions.CREATE_REQUEST:
    case actions.UPDATE_REQUEST:
      return { ...state, saving: true, error: null };
    case actions.CREATE_SUCCESS:
    case actions.UPDATE_SUCCESS:
      return { ...state, saving: false };
    case actions.CREATE_ERROR:
    case actions.UPDATE_ERROR:
      return { ...state, saving: false, error: action.error };
    case actions.DETAIL_REQUEST:
      return { ...state, loadingDetail: true, error: null };
    case actions.DETAIL_SUCCESS:
      return { ...state, loadingDetail: false, detail: action.detail };
    case actions.DETAIL_ERROR:
      return {
        ...state,
        loadingDetail: false,
        detail: null,
        error: action.error,
      };
    case actions.CURRENT_REQUEST:
      return { ...state, loadingCurrent: true };
    case actions.CURRENT_SUCCESS:
      return { ...state, loadingCurrent: false, current: action.current || null };
    case actions.CURRENT_ERROR:
      return { ...state, loadingCurrent: false, current: null };
    case actions.HISTORIES_REQUEST:
      return { ...state, loadingHistories: true };
    case actions.HISTORIES_SUCCESS:
      return {
        ...state,
        loadingHistories: false,
        histories: Array.isArray(action.histories) ? action.histories : [],
      };
    case actions.HISTORIES_ERROR:
      return { ...state, loadingHistories: false, histories: [] };
    case actions.RESET_DETAIL:
      return {
        ...state,
        detail: null,
        current: null,
        histories: [],
        loadingDetail: false,
        loadingCurrent: false,
        loadingHistories: false,
        error: null,
      };
    default:
      return state;
  }
}
